var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { useAuth } from '../../../providers/AuthProvider';
import { useUsers2 } from '@data/hooks/usersAndGroups';
import { EntityType, getPermissionMapsByEntityType } from '@data/permission/permission';
import { usersApi, userGroupsApi } from '@data/rest/api';
import BorderdContainer from '@main/conf/managers/BorderedContainer';
import Tabs from '@main/conf/managers/Tabs';
import { useDebounce } from '@hooks/useDebounce';
import SearchInput from '@shared/input/SearchInput';
import FSSwitch from '@components/FSSwitch';
import List from '@shared/List';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalHeader from '@shared/modal/ModalHeader';
import { Loading, LoadingWrap } from '@styled/Basic';
import { ModalFooterStyled } from '@styled/Modal';
import Fuse from 'fuse.js';
import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import FSButton from '@components/FSButton';
import { getFuseSearchResult } from '@util/search';
import { useSheetRowsById } from '../../../data/sheetRow/sheetRowHooks';
var PermissionMaps = getPermissionMapsByEntityType();
var FUSE_CONFIG = {
    keys: [{ name: 'title', weight: 1 }],
    threshold: 0.25,
    minMatchCharLength: 2,
    useExtendedSearch: true,
};
function getPermissionsForEntity(entity) {
    var EntityPermissions = PermissionMaps[entity];
    return Object.freeze({
        view: [EntityPermissions.READ, EntityPermissions.READ_TREE],
        edit: [
            EntityPermissions.UPDATE,
            EntityPermissions.UPDATE_TREE,
            EntityPermissions.DELETE,
            EntityPermissions.DELETE_TREE,
        ],
    });
}
function PermissionItem(_a) {
    var item = _a.item, onReadToggle = _a.onReadToggle, onEditToggle = _a.onEditToggle;
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 5 } },
        React.createElement("div", { style: {
                flex: 4,
                paddingLeft: 10,
                maxWidth: '75%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            } },
            React.createElement("h5", { style: { display: 'inline', margin: 0 } }, item.title)),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', flex: 1 } },
            React.createElement(FSSwitch, { checked: item.view, onChange: function () { return onReadToggle(item); } }),
            React.createElement(FSSwitch, { checked: item.edit, onChange: function () { return onEditToggle(item); } }))));
}
function useUserPermissions(dependencies) {
    var currentUser = dependencies.currentUser, entity = dependencies.entity, targetId = dependencies.targetId, perms = dependencies.perms;
    var summedEntityPermissions = getPermissionsForEntity(entity);
    var shareableUsers = useUsers2({
        enabled: !!currentUser,
        select: function (data) {
            return data.map(function (user) {
                var userPermsData = perms.find(function (p) { return p.id === user.id; });
                var userPerms = userPermsData && userPermsData.permissions ? userPermsData.permissions : [];
                var hasTargetPermission = function (p) { return userPerms.some(function (perm) { return p.includes(perm); }); };
                var view = summedEntityPermissions.view.every(hasTargetPermission);
                var edit = summedEntityPermissions.edit.every(hasTargetPermission);
                return {
                    id: user.id,
                    edit: edit,
                    view: view,
                    targetId: targetId,
                    ownerId: user.id,
                    title: "".concat(user.firstName, " ").concat(user.lastName),
                };
            });
        },
    });
    return shareableUsers;
}
function useRolePermissions(dependencies) {
    var currentUser = dependencies.currentUser, entity = dependencies.entity, targetId = dependencies.targetId, perms = dependencies.perms;
    var summedEntityPermissions = getPermissionsForEntity(entity);
    var shareableRoles = useQuery(['roles'], function () { return userGroupsApi.list(); }, {
        enabled: !!currentUser,
        select: function (data) {
            return data.map(function (userGroup) {
                var rolePermsData = perms.find(function (p) { return p.id === userGroup.id; });
                var rolePerms = rolePermsData && rolePermsData.permissions ? rolePermsData.permissions : [];
                var hasTargetPermission = function (p) { return rolePerms.some(function (perm) { return p.includes(perm); }); };
                var view = summedEntityPermissions.view.every(hasTargetPermission);
                var edit = summedEntityPermissions.edit.every(hasTargetPermission);
                return {
                    id: userGroup.id,
                    edit: edit,
                    view: view,
                    targetId: targetId,
                    ownerId: userGroup.id,
                    title: userGroup.name,
                };
            });
        },
    });
    return shareableRoles;
}
function getSelectedItems(command) {
    var filteredItems = command.filteredItems, userPermissionItems = command.userPermissionItems, rolePermissionItems = command.rolePermissionItems, selectedTab = command.selectedTab;
    if (filteredItems) {
        return filteredItems;
    }
    if (userPermissionItems && selectedTab === 'Users') {
        return userPermissionItems;
    }
    if (rolePermissionItems && selectedTab === 'Groups') {
        return rolePermissionItems;
    }
    return [];
}
function ShareModal(_a) {
    var _this = this;
    var targetId = _a.targetId, entity = _a.entity;
    var L = useLanguage().L;
    var _b = __read(useState('Users'), 2), selectedTab = _b[0], setSelectedTab = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState([]), 2), userPerms = _d[0], setUserPerms = _d[1];
    var _e = __read(useState([]), 2), rolePerms = _e[0], setRolePerms = _e[1];
    var sheetRowsById = useSheetRowsById();
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var uPerms, rPerms;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, usersApi.searchUserEntityPermissions({
                                type: entity,
                                targetId: targetId,
                            })];
                    case 1:
                        uPerms = _a.sent();
                        if (uPerms) {
                            setUserPerms(uPerms);
                            if (selectedTab === 'Users')
                                setLoading(false);
                        }
                        return [4 /*yield*/, userGroupsApi.searchUserGroupEntityPermissions({
                                type: entity,
                                targetId: targetId,
                            })];
                    case 2:
                        rPerms = _a.sent();
                        if (rPerms) {
                            setRolePerms(rPerms);
                            if (selectedTab === 'Groups')
                                setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [targetId, entity]);
    var entityType = [EntityType.SHEET_ROW, EntityType.DOCUMENT, EntityType.TAG].find(function (e) { return e.includes(entity); }) ||
        EntityType.SHEET_ROW;
    var currentUser = useAuth().user;
    var _f = __read(useState(''), 2), searchString = _f[0], setSearchString = _f[1];
    var debouncedSearchString = useDebounce(searchString, 500);
    var userPermissionItems = useUserPermissions({ entity: entityType, targetId: targetId, currentUser: currentUser, perms: userPerms });
    var rolePermissionItems = useRolePermissions({
        entity: entityType,
        targetId: targetId,
        currentUser: currentUser,
        perms: rolePerms,
    });
    var fuse = useMemo(function () {
        if (selectedTab === 'Groups' && rolePermissionItems.data) {
            return new Fuse(rolePermissionItems.data, FUSE_CONFIG);
        }
        if (selectedTab === 'Users' && userPermissionItems.data) {
            return new Fuse(userPermissionItems.data, FUSE_CONFIG);
        }
    }, [userPermissionItems.data, rolePermissionItems.data, selectedTab]);
    var filteredItems = useMemo(function () {
        return getFuseSearchResult(debouncedSearchString, fuse);
    }, [debouncedSearchString, fuse]);
    var EntityPermissions = getPermissionsForEntity(entityType);
    var toPermission = function (p) { return ({ name: p, targetId: targetId }); };
    var viewPermissions = EntityPermissions.view.map(toPermission);
    var editPermissions = EntityPermissions.edit.map(toPermission);
    var addPermissionHelper = function (state, id, newperms) {
        var filtered = state.filter(function (up) { return up.id !== id; });
        var find = state.find(function (up) { return up.id === id; });
        if (find) {
            newperms.forEach(function (p) {
                if (!(find === null || find === void 0 ? void 0 : find.permissions.includes(p.name))) {
                    find === null || find === void 0 ? void 0 : find.permissions.push(p.name);
                }
            });
        }
        else {
            find = { id: id, permissions: newperms.map(function (p) { return p.name; }) };
        }
        return __spreadArray(__spreadArray([], __read(filtered), false), [find], false);
    };
    var removePermissionHelper = function (state, id, newperms) {
        var filtered = state.filter(function (up) { return up.id !== id; });
        var find = state.find(function (up) { return up.id === id; });
        if (find) {
            var ps_1 = newperms.map(function (p) { return p.name; });
            find.permissions = find.permissions.filter(function (p) { return !ps_1.includes(p); });
        }
        return find ? __spreadArray(__spreadArray([], __read(filtered), false), [find], false) : __spreadArray([], __read(filtered), false);
    };
    function getSheetRowAncestorPermissions(permissions) {
        var target = permissions.find(function (p) { return p.name === 'ENTITY.SHEET_ROW.READ_TREE'; });
        var ancestorPermissions = [];
        var row = (target === null || target === void 0 ? void 0 : target.targetId) ? sheetRowsById[target.targetId] : null;
        if (row) {
            var current = row;
            do {
                current = (current === null || current === void 0 ? void 0 : current.parentId) ? sheetRowsById[current.parentId] : null;
                if (current) {
                    ancestorPermissions.push({ name: 'ENTITY.SHEET_ROW.READ', targetId: current.id });
                }
            } while (current);
        }
        return ancestorPermissions;
    }
    var addPermissions = function (_a) {
        var id = _a.id, permissions = _a.permissions;
        return __awaiter(_this, void 0, void 0, function () {
            var ancestorPermissions, allPermissions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ancestorPermissions = getSheetRowAncestorPermissions(permissions);
                        allPermissions = __spreadArray(__spreadArray([], __read(permissions), false), __read(ancestorPermissions), false);
                        if (!(selectedTab === 'Users')) return [3 /*break*/, 2];
                        setUserPerms(addPermissionHelper(userPerms, id, permissions));
                        return [4 /*yield*/, usersApi.addPermissions(id, { permissions: allPermissions })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(selectedTab === 'Groups')) return [3 /*break*/, 4];
                        setRolePerms(addPermissionHelper(rolePerms, id, permissions));
                        return [4 /*yield*/, userGroupsApi.addPermissions(id, { permissions: allPermissions })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var removePermissions = function (_a) {
        var id = _a.id, permissions = _a.permissions;
        return __awaiter(_this, void 0, void 0, function () {
            var ancestorPermissions, allPermissions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ancestorPermissions = getSheetRowAncestorPermissions(permissions);
                        allPermissions = __spreadArray(__spreadArray([], __read(permissions), false), __read(ancestorPermissions), false);
                        if (!(selectedTab === 'Users')) return [3 /*break*/, 2];
                        setUserPerms(removePermissionHelper(userPerms, id, permissions));
                        return [4 /*yield*/, usersApi.removePermissions(id, { permissions: allPermissions })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(selectedTab === 'Groups')) return [3 /*break*/, 4];
                        setRolePerms(removePermissionHelper(rolePerms, id, permissions));
                        return [4 /*yield*/, userGroupsApi.removePermissions(id, { permissions: allPermissions })];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    function readToggleHandler(item) {
        return __awaiter(this, void 0, void 0, function () {
            var view, edit, ownerId, payload;
            return __generator(this, function (_a) {
                view = item.view, edit = item.edit, ownerId = item.ownerId;
                payload = {
                    id: ownerId,
                    permissions: [],
                };
                if (!view) {
                    payload.permissions = viewPermissions;
                    addPermissions(payload);
                    return [2 /*return*/];
                }
                if (edit) {
                    payload.permissions = __spreadArray(__spreadArray([], __read(viewPermissions), false), __read(editPermissions), false);
                    removePermissions(payload);
                    return [2 /*return*/];
                }
                payload.permissions = viewPermissions;
                removePermissions(payload);
                return [2 /*return*/];
            });
        });
    }
    function editToggleHandler(item) {
        return __awaiter(this, void 0, void 0, function () {
            var view, edit, ownerId, payload;
            return __generator(this, function (_a) {
                view = item.view, edit = item.edit, ownerId = item.ownerId;
                payload = { id: ownerId, permissions: [] };
                if (edit) {
                    payload.permissions = editPermissions;
                    removePermissions(payload);
                    return [2 /*return*/];
                }
                if (!view) {
                    payload.permissions = __spreadArray(__spreadArray([], __read(viewPermissions), false), __read(editPermissions), false);
                    addPermissions(payload);
                    return [2 /*return*/];
                }
                payload.permissions = editPermissions;
                addPermissions(payload);
                return [2 /*return*/];
            });
        });
    }
    function renderPermissionItem(item) {
        return (React.createElement(PermissionItem, { key: item.ownerId, item: item, onEditToggle: editToggleHandler, onReadToggle: readToggleHandler }));
    }
    return (React.createElement(Modal, { width: 500, height: 525 },
        React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(ModalHeader, { title: L('Share') }),
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column', flexGrow: 1, margin: 30 } },
                React.createElement(Tabs, { tabNames: ['Users', 'Groups'], selected: selectedTab, onTabChange: function (tab) {
                        setSelectedTab(tab);
                    } }),
                React.createElement(BorderdContainer, { style: { position: 'relative' } },
                    React.createElement(SearchInput, { name: "search", value: searchString, placeholder: L('Search'), onChange: function (e) { return setSearchString(e.target.value); } }),
                    loading ? (React.createElement(LoadingWrap, null,
                        React.createElement(Loading, { "$size": 2 }))) : (React.createElement(List, { Header: function (props) { return (React.createElement("div", __assign({}, props, { style: __assign(__assign({}, props.style), { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 5, backgroundColor: 'white', zIndex: 1, borderBottom: '1px solid #E7EAF0' }) }),
                            React.createElement("div", { style: { flex: 4, paddingLeft: 10, maxWidth: '75%' } },
                                React.createElement("span", null, L('Name'))),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-evenly',
                                    flex: 1,
                                } },
                                React.createElement("span", null, L('View')),
                                React.createElement("span", null, L('Edit'))))); }, items: getSelectedItems({
                            filteredItems: filteredItems,
                            rolePermissionItems: rolePermissionItems.data,
                            userPermissionItems: userPermissionItems.data,
                            selectedTab: selectedTab,
                        }), renderItem: renderPermissionItem })))),
            React.createElement(ModalFooterStyled, null,
                React.createElement(FSButton, { "$type": "tertiary", title: L('Close'), onClick: Manager.closeModal })))));
}
export default ShareModal;
